/* eslint-disable react/no-deprecated */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/prop-types */

import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
  GoogleMap,
  Marker,
  DirectionsService,
  DirectionsRenderer,
  Polygon,
  InfoWindow,
} from '@react-google-maps/api';
import PropTypes from 'prop-types';
import cookieMarker from './images/cookieMarker.png';
// #19021 temporary — Figma Archive Old Logo pins (teardrop + moon-cookie).
// Restore brand-refresh pins when company logo rollout is confirmed:
// import cookieMarkerBrandRefresh from './images/cookieMarkerBrandRefresh.svg';
// import cookieMarkerBrandRefreshSelected from './images/cookieMarkerBrandRefreshSelected.svg';
import cookieMarkerLegacyPin from './images/cookieMarkerLegacyPin.svg';
import cookieMarkerLegacyPinSelected from './images/cookieMarkerLegacyPinSelected.svg';
import cookieMarkerBrandRefresh from './images/cookieMarkerBrandRefresh.svg';
import cookieMarkerBrandRefreshSelected from './images/cookieMarkerBrandRefreshSelected.svg';
import locationMarker from './images/locationMarker.png';
import deliveryMarker from './images/DeliveryTracker.png';
import mapZoomPlusBrandRefresh from './images/map-zoom-plus-brand-refresh.svg';
import mapZoomMinusBrandRefresh from './images/map-zoom-minus-brand-refresh.svg';
import mapGpsArrowBrandRefresh from './images/map-gps-arrow-brand-refresh.svg';
import mapCardCloseX from './images/map-card-close-x.svg';


import styles from './MapComponent.module.css';
import './MapComponentBrandRefresh.module.css';
import MarkerComponent from './MarkerComponent';
import * as userActions from "../../redux/actions/user";
import {orderTypeIds} from "../../shared/constants/order";
import Loader from '../Loader/Loader';
import {
  BRAND_REFRESH_DEFAULT_CENTER,
  BRAND_REFRESH_MAP_STYLE,
  fitBrandRefreshLocationsViewport,
  getBrandRefreshStoreMarkerIcon,
  getBrandRefreshUserLocationIcon,
} from '../../shared/utilities/brandRefreshMapStyles';
import { getStorePickupHoursStatus } from '../../shared/utilities/storeHoursStatus';
import {
  formatBrandRefreshStoreDistance,
  formatBrandRefreshStorePhone,
  truncateBrandRefreshStoreAddress,
} from '../LocationsListItem/locationsListItemBrandRefreshClasses';
import {
  getStorefrontImageSrc,
  handleStorefrontImageError,
} from '../../shared/utilities/storefrontFallback';
import { storeTypes } from '../../shared/constants/store';

/** Aligns with Find a Bakery mobile layout (@media max-width: 767px). */
export const MAP_MOBILE_GESTURE_MAX_WIDTH = 767;

/** Desktop pin card size — Figma Tooltip Card 4984:20597 */
export const BRAND_REFRESH_DESKTOP_CARD = {
  width: 271,
  height: 280,
  gap: 16,
  margin: 12,
  pinHeight: 48,
};


/**
 * Mobile: greedy (one-finger pan). Desktop: cooperative (two-finger pan / page scroll).
 * Shared by Find a Bakery Results and Store Details (#18774).
 * @param {number} [width]
 * @returns {'greedy'|'cooperative'}
 */
export const getMapGestureHandling = (width) => {
  let viewportWidth = MAP_MOBILE_GESTURE_MAX_WIDTH + 1;
  if (typeof width === 'number') {
    viewportWidth = width;
  } else if (typeof window !== 'undefined') {
    viewportWidth = window.innerWidth;
  }
  return viewportWidth <= MAP_MOBILE_GESTURE_MAX_WIDTH ? 'greedy' : 'cooperative';
};
/**
 * Airbnb-style InfoWindow offset so the desktop pin card stays fully on-map (#18773).
 * Places the card beside the pin when possible; falls back above/below near edges.
 * @param {{ mapWidth: number, mapHeight: number, markerX: number, markerY: number }} dims
 * @returns {{ x: number, y: number }}
 */
export const getBrandRefreshInfoWindowPixelOffset = ({
  mapWidth,
  mapHeight,
  markerX,
  markerY,
}) => {
  const {
    width: cardW,
    height: cardH,
    gap,
    margin,
    pinHeight,
  } = BRAND_REFRESH_DESKTOP_CARD;
  const halfW = cardW / 2;
  const halfH = cardH / 2;
  const preferRight = markerX < mapWidth / 2;
  const spaceRight = mapWidth - margin - markerX;
  const spaceLeft = markerX - margin;
  const safeMapHeight = typeof mapHeight === 'number' && mapHeight > 0
    ? mapHeight
    : cardH + margin * 2;

  const clampSideOffsetY = (rawY) => {
    // Tip is bottom-center of IW; keep card body inside map vertically.
    const tipY = markerY + rawY;
    const cardTop = tipY - cardH;
    const cardBottom = tipY;
    let adjusted = rawY;
    if (cardTop < margin) {
      adjusted += margin - cardTop;
    }
    if (cardBottom > safeMapHeight - margin) {
      adjusted -= cardBottom - (safeMapHeight - margin);
    }
    return adjusted;
  };

  // Tip is bottom-center of InfoWindow; tip CSS-hidden — place card body beside pin.
  if (preferRight && spaceRight >= cardW + gap) {
    return { x: gap + halfW, y: clampSideOffsetY(halfH - pinHeight / 2) };
  }
  if (!preferRight && spaceLeft >= cardW + gap) {
    return { x: -(gap + halfW), y: clampSideOffsetY(halfH - pinHeight / 2) };
  }
  if (preferRight && spaceLeft >= cardW + gap) {
    return { x: -(gap + halfW), y: clampSideOffsetY(halfH - pinHeight / 2) };
  }
  if (!preferRight && spaceRight >= cardW + gap) {
    return { x: gap + halfW, y: clampSideOffsetY(halfH - pinHeight / 2) };
  }

  // Fallback: above pin, clamp horizontally so card is not cut off.
  const minCenterX = margin + halfW;
  const maxCenterX = mapWidth - margin - halfW;
  const desiredCenterX = Math.min(Math.max(markerX, minCenterX), maxCenterX);
  const offsetX = desiredCenterX - markerX;

  let offsetY = -pinHeight;
  if (markerY - cardH - pinHeight < margin) {
    offsetY = cardH + gap;
  }

  return { x: offsetX, y: offsetY };
};

const DarkThemeConstant = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#263c3f" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#6b9a76" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#38414e" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212a37" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#746855" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#1f2835" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#f3d19c" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#17263c" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#515c6d" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#17263c" }],
  },
];

class MapComponent extends Component {
  constructor() {
    super();
    this.mapInstance = null;
    this.lastBrandRefreshFitKey = null;
    this.state = {
      travelMode: 'DRIVING',
      myLocation: { lat: '', lng: '' },
      response: null,
      geolocateLoading: false,
    };
  }

  componentWillReceiveProps(props) {
    const { myLocation } = props;
    this.setState({ myLocation });
  }

  componentDidUpdate(prevProps) {
    const { isBrandRefresh, mode, stores, center } = this.props;
    if (!isBrandRefresh || mode !== 'locations') {
      return;
    }

    const prevStoreKey = this.getBrandRefreshFitKey(
      prevProps.stores,
      prevProps.center
    );
    const nextStoreKey = this.getBrandRefreshFitKey(stores, center);
    if (prevStoreKey !== nextStoreKey) {
      this.fitBrandRefreshViewport();
    }
  }

  getBrandRefreshFitKey = (stores, center) => {
    const storeKey = (stores || [])
      .map((store) => `${store.id || ''}:${store.lat},${store.lng}`)
      .join('|');
    const centerKey =
      center?.lat != null && center?.lng != null
        ? `${center.lat},${center.lng}`
        : '';
    return `${centerKey}::${storeKey}`;
  }

  fitBrandRefreshViewport = () => {
    const {
      isBrandRefresh,
      mode,
      stores,
      center,
      disableMarkerSelection,
      zoom: zoomProp,
    } = this.props;
    
    if (
      !isBrandRefresh ||
      mode !== 'locations' ||
      !this.mapInstance ||
      disableMarkerSelection ||
      typeof zoomProp === 'number'
    ) {
      return;
    }

    const { google } = window;
    if (!google?.maps) {
      return;
    }

    const fitKey = this.getBrandRefreshFitKey(stores, center);
    if (fitKey === this.lastBrandRefreshFitKey) {
      return;
    }

    const fitted = fitBrandRefreshLocationsViewport(this.mapInstance, google, {
      stores,
      center,
    });
    if (fitted) {
      this.lastBrandRefreshFitKey = fitKey;
    }
  }

  getDefaultZoomFromMode = (mode) => {
    let zoom = 14;
    switch (mode) {
      case 'directions':
        zoom = 16;
        break;
      case 'locations':
        zoom = 14;
        break;
      case 'static':
        zoom = 18;
        break;
      default:
        zoom = 14;
        break;
    }
    return zoom;
  }

  handleMapLoad = (map) => {
    const { onMapLoad } = this.props;
    this.mapInstance = map;
    this.lastBrandRefreshFitKey = null;

    const mapContainer = map.getDiv();
    if (mapContainer) {
      mapContainer.setAttribute("tabindex", "0");
      mapContainer.setAttribute("role", "application");
      mapContainer.setAttribute(
        "aria-label",
        "Interactive map showing store locations"
      );
    }

    this.fitBrandRefreshViewport();

    if (onMapLoad) {
      onMapLoad(map);
    }
  };

  adjustMapZoom = (delta) => {
    if (!this.mapInstance) {
      return;
    }
    const currentZoom = this.mapInstance.getZoom() ?? 14;
    const nextZoom = currentZoom + delta;
    this.mapInstance.setZoom(delta < 0 ? Math.max(nextZoom, 1) : nextZoom);
  };

  handleZoomIn = () => {
    this.adjustMapZoom(1);
  };

  handleZoomOut = () => {
    this.adjustMapZoom(-1);
  };

  handleGeolocateClick = () => {
    if (!navigator?.geolocation) {
      return;
    }

    this.setState({ geolocateLoading: true });
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const nextLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.setState({
          myLocation: nextLocation,
          geolocateLoading: false,
        });
        if (this.mapInstance) {
          this.mapInstance.panTo(nextLocation);
          this.mapInstance.setZoom(15);
        }
      },
      () => {
        this.setState({ geolocateLoading: false });
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  renderBrandRefreshMapControls = () => {
    const { isBrandRefresh, hideGeolocateControl, disableMarkerSelection } = this.props;
    const { geolocateLoading } = this.state;
    if (!isBrandRefresh) {
      return null;
    }

    const showGpsControl = !hideGeolocateControl && !disableMarkerSelection;

    return (
      <div data-part="map-controls">
        {showGpsControl ? (
          <button
            type="button"
            data-part="map-gps-btn"
            aria-label="Use my location"
            disabled={geolocateLoading}
            onClick={this.handleGeolocateClick}
          >
            <img
              alt=""
              src={mapGpsArrowBrandRefresh}
              data-part="map-gps-icon"
              aria-hidden="true"
            />
          </button>
        ) : null}
        <div data-part="map-zoom">
          <button
            type="button"
            data-part="map-zoom-btn"
            aria-label="Zoom in"
            onClick={this.handleZoomIn}
          >
            <img
              alt=""
              src={mapZoomPlusBrandRefresh}
              data-part="map-zoom-icon"
              aria-hidden="true"
            />
          </button>
          <hr data-part="map-zoom-divider" />
          <button
            type="button"
            data-part="map-zoom-btn"
            aria-label="Zoom out"
            onClick={this.handleZoomOut}
          >
            <img
              alt=""
              src={mapZoomMinusBrandRefresh}
              data-part="map-zoom-icon"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    );
  };

  handleStoreClick = (store) => {
    const { setSelectedMapStore } = this.props;

    setSelectedMapStore(store);
  }

  getStoreMarkerTitle = (store) => {
    const street = store.address1 || store.address || '';
    const locality = [store.city, store.state].filter(Boolean).join(', ');
    if (street && locality) {
      return `${store.name} - ${street}, ${locality}`;
    }
    if (street) {
      return `${store.name} - ${street}`;
    }
    if (locality) {
      return `${store.name} - ${locality}`;
    }
    return store.name || 'Store location';
  };

  /**
   * #18773 Carlos: dismiss pin card when clicking empty map (not drag/pinch/zoom).
   * Google Maps only fires map `click` for a true click — pan/zoom gestures do not.
   */
  handleBrandRefreshMapClick = () => {
    const {
      isBrandRefresh,
      disableMarkerSelection,
      selectedMapStore,
      setSelectedMapStore,
    } = this.props;

    if (
      !isBrandRefresh
      || disableMarkerSelection
      || !selectedMapStore
      || typeof setSelectedMapStore !== 'function'
    ) {
      return;
    }

    setSelectedMapStore(null);
  }

  handleBrandRefreshInfoClose = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const { setSelectedMapStore } = this.props;
    setSelectedMapStore(null);
  }

  handleBrandRefreshStoreDetailClick = (store) => {
    const { onBrandRefreshStoreDetailClick } = this.props;
    if (typeof onBrandRefreshStoreDetailClick === 'function') {
      onBrandRefreshStoreDetailClick(store);
    }
  }

  isBrandRefreshMobileMap = () => (
    typeof window !== 'undefined'
    && window.innerWidth <= MAP_MOBILE_GESTURE_MAX_WIDTH
  );

  getDesktopInfoWindowPixelOffset = (store) => {
    const fallback = { x: 0, y: -BRAND_REFRESH_DESKTOP_CARD.pinHeight };
    if (
      !this.mapInstance
      || !store
      || !window.google
      || !window.google.maps
    ) {
      return fallback;
    }

    const projection = this.mapInstance.getProjection
      && this.mapInstance.getProjection();
    const bounds = this.mapInstance.getBounds && this.mapInstance.getBounds();
    const mapDiv = this.mapInstance.getDiv && this.mapInstance.getDiv();
    if (!projection || !bounds || !mapDiv) {
      return fallback;
    }

    const mapWidth = mapDiv.clientWidth || 0;
    const mapHeight = mapDiv.clientHeight || 0;
    if (!mapWidth || !mapHeight) {
      return fallback;
    }

    const latLng = new window.google.maps.LatLng(store.lat, store.lng);
    const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
    const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
    const worldPoint = projection.fromLatLngToPoint(latLng);
    if (!topRight || !bottomLeft || !worldPoint) {
      return fallback;
    }

    const mapWorldWidth = Math.abs(topRight.x - bottomLeft.x) || 1;
    const mapWorldHeight = Math.abs(bottomLeft.y - topRight.y) || 1;
    const markerX = ((worldPoint.x - bottomLeft.x) / mapWorldWidth) * mapWidth;
    const markerY = ((worldPoint.y - topRight.y) / mapWorldHeight) * mapHeight;

    return getBrandRefreshInfoWindowPixelOffset({
      mapWidth,
      mapHeight,
      markerX,
      markerY,
    });
  };

  renderBrandRefreshStoreCardContent = (store) => {
    const isComingSoon = store.storeType === storeTypes.COMINGSOON;
    const hoursStatus = getStorePickupHoursStatus(store.hours);
    const isOpen = hoursStatus
      ? hoursStatus.isOpen
      : Boolean(store.isPickupOpen);
    let statusLabel;
    let statusDataAttr;
    if (isComingSoon) {
      statusLabel = 'Coming Soon';
      statusDataAttr = 'coming-soon';
    } else if (isOpen) {
      statusLabel = 'Open';
      statusDataAttr = 'open';
    } else {
      statusLabel = 'Closed';
      statusDataAttr = 'closed';
    }
    const hoursText = !isComingSoon && hoursStatus?.hoursText
      ? hoursStatus.hoursText
      : '';
    const distance = store.distanceToStore
      ? formatBrandRefreshStoreDistance(store.distanceToStore)
      : '';
    const addressParts = [
      store.address1 || store.mailingAddress,
      store.city,
      store.state,
    ].filter(Boolean);
    const address = addressParts.join(', ');
    const truncatedAddress = truncateBrandRefreshStoreAddress(address);
    const phone = formatBrandRefreshStorePhone(store.phone || store.telephone);
    const imageSrc = getStorefrontImageSrc(
      store.storefrontImage || store.storeImage
    );

    return (
      <div data-part="map-store-card">
        <button
          type="button"
          data-part="map-store-card-close"
          aria-label="Close store card"
          onClick={this.handleBrandRefreshInfoClose}
        >
          <img src={mapCardCloseX} alt="" aria-hidden="true" />
        </button>
        <div
          role="button"
          tabIndex={0}
          data-part="map-store-card-open"
          aria-label={`View details for ${store.name}`}
          onClick={() => this.handleBrandRefreshStoreDetailClick(store)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.handleBrandRefreshStoreDetailClick(store);
            }
          }}
        >
          <img
            key={store.id != null ? String(store.id) : imageSrc}
            data-part="map-store-card-image"
            data-store-id={store.id != null ? String(store.id) : undefined}
            src={imageSrc}
            alt=""
            onError={handleStorefrontImageError}
          />
          <div data-part="map-store-card-body">
            <div data-part="map-store-card-title-row">
              <h3 data-part="map-store-card-name">{store.name}</h3>
            </div>
            <p data-part="map-store-card-meta">
              <span
                data-part="map-store-card-status"
                data-status={statusDataAttr}
              >
                {statusLabel}
              </span>
              {hoursText ? (
                <>
                  <span data-part="map-store-card-sep" aria-hidden="true">
                    {' '}
                    ·
                    {' '}
                  </span>
                  <span>{hoursText}</span>
                </>
              ) : null}
              {distance ? (
                <>
                  <span data-part="map-store-card-sep" aria-hidden="true">
                    {' '}
                    ·
                    {' '}
                  </span>
                  <span>{distance}</span>
                </>
              ) : null}
            </p>
            {address ? (
              <>
                <p data-part="map-store-card-address">{address}</p>
                <p data-part="map-store-card-address-truncated">
                  {truncatedAddress}
                </p>
              </>
            ) : null}
            {phone ? (
              <p data-part="map-store-card-phone">{phone}</p>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  renderBrandRefreshStoreInfoWindow = (store) => {
    if (!store) {
      return null;
    }

    const offset = this.getDesktopInfoWindowPixelOffset(store);
    const pixelOffset =
      window.google && window.google.maps && window.google.maps.Size
        ? new window.google.maps.Size(offset.x, offset.y)
        : undefined;

    return (
      <InfoWindow
        position={{ lat: store.lat, lng: store.lng }}
        onCloseClick={this.handleBrandRefreshInfoClose}
        options={{
          pixelOffset,
          maxWidth: BRAND_REFRESH_DESKTOP_CARD.width + 24,
          disableAutoPan: true,
        }}
      >
        {this.renderBrandRefreshStoreCardContent(store)}
      </InfoWindow>
    );
  }

  renderBrandRefreshMobileStoreCardDock = (store) => {
    if (!store) {
      return null;
    }

    return (
      <div
        key={store.id != null ? String(store.id) : undefined}
        data-part="map-store-card-dock"
      >
        {this.renderBrandRefreshStoreCardContent(store)}
      </div>
    );
  }

  /**
   * Handles direction response
   * @param {object} response - response object
   */
  directionsCallback = response => {
    if (response !== null && response.status === 'OK') {
      this.setState({ response });
    }
  };

  locationsContainer = () => {
    const {
      stores,
      selectedStoreId,
      isBrandRefresh,
      selectedMapStore,
      disableMarkerSelection,
    } = this.props;

    /* Hard coded paths for polygon shape to render on the map */
    const pathsOne = [
      { lat: 40.72477201717212, lng: -73.99263416810369 },
      { lat: 40.7172261389474, lng: -73.99520908875799 },
      { lat: 40.7172261389474, lng: -73.97529636903143 },
      { lat: 40.72386142859243, lng: -73.97353645130801 },
      { lat: 40.72347128202988, lng: -73.9813898565416 }
    ];

    const centerOne = { lat: 40.72099507923205, lng: -73.984051099256 };

    const pathsTwo = [
      { lat: 40.728865745926, lng: -74.00859867616033 },
      { lat: 40.72522323902838, lng: -73.99520908875799 },
      { lat: 40.730817006895045, lng: -73.98851429505682 },
      { lat: 40.73810120895293, lng: -74.0082553534064 }
    ];

    const centerTwo = { lat: 40.73159749526159, lng: -74.0012172369513 };

    const options = {
      fillColor: '#5e2975',
      fillOpacity: 0.2,
      strokeColor: '#5e2975',
      strokeOpacity: 1,
      strokeWeight: 2,
      clickable: false,
      draggable: false,
      editable: false,
      geodesic: false,
      zIndex: 1
    };

    const getStoreMarkerIcon = (store) => {
      const { google } = window;
      if (!isBrandRefresh) {
        return {
          url: cookieMarker,
          scaledSize:
            selectedStoreId === store.id && google?.maps?.Size
              ? new google.maps.Size(40, 40)
              : null,
        };
      }
      // temporary — Figma Archive Old Logo pin styling (9611:55747).
      // Restore:
      //   if (!google?.maps?.Size) return { url: cookieMarkerBrandRefresh };
      //   return getBrandRefreshStoreMarkerIcon(
      //     google, selectedStoreId === store.id,
      //     cookieMarkerBrandRefresh, cookieMarkerBrandRefreshSelected,
      //   );
      if (!google?.maps?.Size) {
        return { url: cookieMarkerLegacyPin };
      }
      return getBrandRefreshStoreMarkerIcon(
        google,
        selectedStoreId === store.id,
        cookieMarkerLegacyPin,
        cookieMarkerLegacyPinSelected,
      );
    };

    if (stores?.length) {
      const { google } = window;

      return (
        <div>
          {stores.map((store) => {
            let storePath = null;
            if (!isBrandRefresh && store.boundary) {
              try {
                storePath = JSON.parse(store.boundary);
                if (!(storePath instanceof Array)) {
                  storePath = Object.values(storePath);
                }
              } catch (e) {
                storePath = null;
              }
            }

            // Keep children order: Marker, InfoWindow|null, Polygon|null
            // (results list + store details + existing MapComponent tests).
            const isSelected = selectedStoreId === store.id;
            const markerTitle = this.getStoreMarkerTitle(store);
            const showInfoWindow =
              isBrandRefresh &&
              !disableMarkerSelection &&
              !this.isBrandRefreshMobileMap() &&
              selectedMapStore &&
              selectedMapStore.id === store.id;
            if (isBrandRefresh) {
              // Store Details uses the default purple pin (Figma). Selected/cream
              // pin is only for Results list multi-pin selection.
              return (
                <div
                  key={
                    store.id != null ? String(store.id) : store.lat.toString()
                  }
                >
                  <Marker
                    icon={getBrandRefreshStoreMarkerIcon(
                      google,
                      isSelected,
                      cookieMarkerBrandRefresh,
                      cookieMarkerBrandRefreshSelected
                    )}
                    zIndex={isSelected ? 10 : 1}
                    position={{lat: store.lat, lng: store.lng}}
                    onClick={() => {
                      if (disableMarkerSelection) {
                        return;
                      }
                      this.handleStoreClick(store);
                    }}
                    title={markerTitle}
                    options={{
                      title: markerTitle,
                      optimized: false
                    }}
                  />
                  {showInfoWindow
                    ? this.renderBrandRefreshStoreInfoWindow(selectedMapStore)
                    : null}
                </div>
              );
            }

            return (
              <div
                key={
                  store.id != null ? String(store.id) : store.lat.toString()
                }
              >
                <Marker
                  icon={getStoreMarkerIcon(store)}
                  animation={
                    !isBrandRefresh && isSelected
                      ? google.maps.Animation.BOUNCE
                      : null
                  }
                  position={{lat: store.lat, lng: store.lng}}
                  onClick={() => {
                    if (disableMarkerSelection) {
                      return;
                    }
                    this.handleStoreClick(store);
                  }}
                  title={markerTitle}
                  zIndex={isBrandRefresh && isSelected ? 10 : 1}
                  options={{
                    title: markerTitle,
                    optimized: false
                  }}
                />
                {showInfoWindow
                  ? this.renderBrandRefreshStoreInfoWindow(selectedMapStore)
                  : null}
                {!isBrandRefresh && storePath ? (
                  <Polygon paths={storePath} options={options} />
                ) : null}
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div>
        <div>
          <Marker
            icon={cookieMarker}
            onLoad={this.cookieOnLoad}
            position={centerOne}
            title="Store location"
            options={{
              title: "Store location",
              optimized: false
            }}
          />
          {!isBrandRefresh ? <Polygon paths={pathsOne} options={options} /> : null}
        </div>
        <div>
          <Marker
            icon={cookieMarker}
            onLoad={this.cookieOnLoad}
            position={centerTwo}
            title="Store location"
            options={{
              title: "Store location",
              optimized: false
            }}
          />
          {!isBrandRefresh ? <Polygon paths={pathsTwo} options={options} /> : null}
        </div>
      </div>
    );
  };

  directionsContainer = () => {
    const { response, travelMode } = this.state;
    const { storeAddress, customerAddress, order } = this.props;
    const isDelivery = order?.orderTypeId === orderTypeIds.delivery
    const origin = {
      lat: parseFloat(storeAddress.lat),
      lng: parseFloat(storeAddress.lng)
    };

    const destination = {
      lat: parseFloat(customerAddress.lat),
      lng: parseFloat(customerAddress.lng)
    };

    return (
      <div>
        {' '}
        {!response ? (
          <DirectionsService
            options={{
            destination,
            origin,
            travelMode
          }}
            callback={this.directionsCallback}
          />
        ) : null}
        {response ? (
          <DirectionsRenderer
            options={{
              directions: response,
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: '#4B1850',
                strokeWeight: 0
              }
            }}
          />
        ) : null}
        <Marker
          icon={cookieMarker}
          position={origin}
          title="Store location"
          options={{
            title: "Store location",
            optimized: false
          }}
        />
        <Marker
          icon={locationMarker}
          position={destination}
          title="Delivery destination"
          options={{
            title: "Delivery destination",
            optimized: false
          }}
        />
        {
          isDelivery ? <MarkerComponent order={order} /> : null
        }
      </div>
    );
  };

  staticContainer = () => {
    const { storeAddress, customerAddress } = this.props;
    const origin = {
      lat: parseFloat(storeAddress.lat),
      lng: parseFloat(storeAddress.lng),
    };

    const destination = {
      lat: parseFloat(customerAddress.lat),
      lng: parseFloat(customerAddress.lng),
    };

    return (
      <div>
        {' '}
        <Marker
          icon={cookieMarker}
          position={origin}
          title="Store location"
          options={{
            title: "Store location",
            optimized: false
          }}
        />
        <Marker
          icon={locationMarker}
          position={destination}
          title="Customer location"
          options={{
            title: "Customer location",
            optimized: false
          }}
        />
      </div>
    );
  };

  handleMapKeyDown = (event) => {
    // Handle keyboard navigation for map markers
    if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') {
      // Allow default tab navigation but prevent space/enter from scrolling
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
      }
    }
  };

  render() {
    const {
      mode,
      center,
      showDefaultMap,
      searchAddress,
      mapDefaultCoordinates,
      driverLocation,
      theme,
      isBrandRefresh,
      zoom: zoomProp,
      selectedMapStore,
      disableMarkerSelection,
    } = this.props;
    const { lat, lng } = mapDefaultCoordinates;
    const { myLocation } = this.state;

    let mapCenter;
    let initialLoc;
    let loading = false;

    if (showDefaultMap) {
      mapCenter = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };
    } else {
      loading = true;
    }

    if (searchAddress?.lng && searchAddress?.lat) {
      initialLoc = {
        lat: searchAddress.lat,
        lng: searchAddress.lng
      }
    }

    // handle map centering for directions
    if (this.props.customerAddress && (mode === 'directions' || mode === 'static')) {
      mapCenter = {
        lat: parseFloat(this.props.customerAddress.lat),
        lng: parseFloat(this.props.customerAddress.lng)
      };
      loading = false;
    } else if (this.props.center && mode === 'locations') {
      mapCenter = center;
      loading = false;
    } else if (isBrandRefresh && mode === 'locations') {
      // avoid a second cookie spinner under Locations' stores-loading
      // overlay while geolocation / center is still resolving.
      mapCenter = BRAND_REFRESH_DEFAULT_CENTER;
      loading = false;
    }

    const zoom = typeof zoomProp === 'number' ? zoomProp : this.getDefaultZoomFromMode(mode);

    let mapStyles = null;
    if (isBrandRefresh) {
      mapStyles = BRAND_REFRESH_MAP_STYLE;
    } else if (theme?.theme === "dark") {
      mapStyles = DarkThemeConstant;
    }

    const getUserLocationIcon = () => {
      if (isBrandRefresh && window.google?.maps?.SymbolPath) {
        return getBrandRefreshUserLocationIcon(window.google);
      }
      return locationMarker;
    };

    return !loading ? (
      <div
        className={styles.mapWrapper}
        data-part={isBrandRefresh ? 'map-wrapper' : undefined}
        tabIndex={-1}
      >
        {this.renderBrandRefreshMapControls()}
        <GoogleMap
          options={{
            fullscreenControl: false,
            mapTypeControl: false,
            scrollwheel: true,
            streetViewControl: false,
            zoomControl: false,
            scaleControl: false,
            rotateControl: false,
            styles: mapStyles,
            keyboardShortcuts: true,
            // Mobile: one-finger pan; desktop keeps two-finger / page-scroll cooperative mode
            gestureHandling: getMapGestureHandling(),
            disableDefaultUI: Boolean(isBrandRefresh),
            disableDoubleClickZoom: false,
            clickableIcons: !isBrandRefresh,
          }}
          mapContainerClassName={styles.mapContainer}
          zoom={zoom}
          center={mapCenter}
          onLoad={this.handleMapLoad}
          onClick={
            isBrandRefresh && !disableMarkerSelection
              ? this.handleBrandRefreshMapClick
              : undefined
          }
          onKeyDown={this.handleMapKeyDown}
          role="application"
          aria-label="Interactive map showing store locations"
          tabIndex={0}
        >
          {myLocation.lat && myLocation.lng ? (
            <Marker
              icon={getUserLocationIcon()}
              onLoad={this.cookieOnLoad}
              position={{ lat: myLocation.lat, lng: myLocation.lng }}
              title="Your current location"
              options={{
                title: "Your current location",
                optimized: false
              }}
            />
          ) : null}
          {!isBrandRefresh && initialLoc ? (
            <Marker
              icon={getUserLocationIcon()}
              position={initialLoc}
              title="Search location"
              options={{
                title: "Search location",
                optimized: false
              }}
            />
          ) : null}
          {driverLocation.lat && driverLocation.lng && (
            <Marker
              icon={deliveryMarker}
              position={{
                lat: parseFloat(driverLocation.lat),
                lng: parseFloat(driverLocation.lng)
              }}
              title="Delivery driver location"
              options={{
                title: "Delivery driver location",
                optimized: false
              }}
            />
          )}
          {mode === "directions" ? <this.directionsContainer /> : null}
          {mode === "locations" ? <this.locationsContainer /> : null}
          {mode === "static" ? <this.staticContainer /> : null}
        </GoogleMap>
        {isBrandRefresh
          && !disableMarkerSelection
          && this.isBrandRefreshMobileMap()
          && selectedMapStore
          ? this.renderBrandRefreshMobileStoreCardDock(selectedMapStore)
          : null}
      </div>
    ) : (
      <div className={styles.loaderWrapper}>
        <Loader />
      </div>
    );
  }
}

MapComponent.propTypes = {
  customerAddress: PropTypes.shape({
      lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }),
  storeAddress: PropTypes.shape({
      lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  searchAddress: PropTypes.shape({
      lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  center: PropTypes.shape({
      lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }),
  myLocation: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  driverLocation: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  mode: PropTypes.string,
  stores: PropTypes.arrayOf(PropTypes.object),
  showDefaultMap: PropTypes.bool.isRequired,
  setSelectedMapStore: PropTypes.func.isRequired,
  onMapLoad: PropTypes.func,
  isBrandRefresh: PropTypes.bool,
  onBrandRefreshStoreDetailClick: PropTypes.func,
  hideGeolocateControl: PropTypes.bool,
  disableMarkerSelection: PropTypes.bool,
  zoom: PropTypes.number,
};

MapComponent.defaultProps = {
  myLocation: { lat: '', lng: '' },
  driverLocation: { lat: '', lng: '' },
  storeAddress: { lat: '', lng: '' },
  searchAddress: { lat: '', lng: ''},
  customerAddress: null,
  stores: [],
  mode: 'directions',
  onMapLoad: null,
  center: null,
  isBrandRefresh: false,
  onBrandRefreshStoreDetailClick: null,
  hideGeolocateControl: false,
  disableMarkerSelection: false,
  zoom: null,
};

export const mapDispatchToProps = (dispatch) => ({
  setSelectedMapStore: (value) => dispatch(userActions.setSelectedMapStore(value))
});

export const mapStateToProps = (state) => {
  const {
    mapDefaultCoordinates
  } = state.elements;

  return {
    mapDefaultCoordinates,
    theme: state.theme,
    selectedMapStore: state.user?.selectedMapStore,
  };
}

export default connect(() => mapStateToProps, mapDispatchToProps)(MapComponent);
